import React, { useState } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import scanAnimation from "assets/lottie/Anti Virus Scanning.json";
import { FraudEntryType, FraudResponse } from "shared/types/types";
import apiInstance from "shared/api/axiosConfig"; // Add your Lottie file

type Props = {
  entryType: FraudEntryType;
  onBack: () => void;
  onNext: (value: string | File | null, result: any | null, error: string | null) => void;
};

export default function FraudStepInput({ entryType, onBack, onNext }: Props) {
  const [value, setValue] = useState<string | File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAnalyze = async () => {
    if (!value) return;
    setLoading(true);
    setError(null);

    try {
      // Example fake API call
      if (typeof value == 'string') {
        await new Promise((r) => setTimeout(r, 2000));
        const result = await callCheck(value as string)
        await new Promise((r) => setTimeout(r, 2000));
        onNext(value, result, null);
      } else {
        await new Promise((r) => setTimeout(r, 2000));
        onNext(value, null, null);
      }

    } catch (err) {
      setError("Erreur lors de l’analyse.");
      onNext(value, null, "Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

  async function callCheck(urlToCheck: string) {
    const API_BASE = apiInstance.getUri();
    const urlParts = urlToCheck.split("/");
    const listingId = urlParts[urlParts.length - 1];
    const r = await fetch(`${API_BASE}/api/fraud-detection/check-annonce`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url: `https://www.leboncoin.fr/ad/voitures/${listingId}` }),
    });
    const text = await r.text();
    if (!r.ok) throw new Error(text.slice(0, 1200));
    return JSON.parse(text) as FraudResponse;
  }

  if (loading) {
    return (
      <div className="loading-step">
        <Lottie animationData={scanAnimation} loop />
        <motion.h3
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ repeat: Infinity, duration: 1.5 }}
        >
          Analyse en cours...
        </motion.h3>
      </div>
    );
  }

  return (
    <div className="step-card">
      <h2>
        {entryType === "url"
          ? "Entrez le lien de l’annonce"
          : "Téléversez une photo de l'annonce"}
      </h2>

      {entryType === "url" ? (
        <input
          type="text"
          className="wizard-input"
          placeholder="https://www.leboncoin.fr/ad/locations/12345"
          onChange={(e) => setValue(e.target.value)}
        />
      ) : (
        <label className="wizard-upload">
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setValue(e.target.files?.[0] || null)}
            hidden
          />
          {value ? "Image sélectionnée" : "Choisir une image"}
        </label>
      )}

      {error && (
        <motion.div
          className="error-box"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          ⚠{error}
        </motion.div>
      )}

      <div className="actions">
        <button className="wizard-btn ghost" onClick={onBack}>
          ← Retour
        </button>
        <button
          className="wizard-btn primary"
          onClick={handleAnalyze}
          disabled={!value}
        >
          Confirmer et analyser →
        </button>
      </div>
    </div>
  );
}
